export const isComplete = (object: any) => {
  return Object.values(object).every(
    (value) => value !== undefined && value !== null && value !== ''
  );
};
